import React from 'react'
import PropTypes from 'prop-types'
import { getReserveLabel, utils } from '@adc/blueprint'

const ListingReserve = ({ listing, elmId }) => {
  const [reserveLabel, reserveValue] = ListingReserve.rawTuple(listing)

  return (
    <div data-elm-id={`reserve_amount_${elmId}`}>
      <label>{reserveLabel}:</label>
      <span>{reserveValue}</span>
    </div>
  )
}

/**
 * NOTE: This is attached here with intention. Products needs this reserve logic but usually all have a slightly
 * different way of displaying it inline: some split with dots, some default with '-' and some display nothing if the
 * reserve is empty.
 */
ListingReserve.rawTuple = (
  listing,
  emptyValue = '',
  callerReserveOverride = null
) => {
  const mostAccurateReserveValueAvailable =
    callerReserveOverride || listing.reserve_price
  const value = mostAccurateReserveValueAvailable
    ? utils.formatMoney(mostAccurateReserveValueAvailable, {
        hideDecimals: false,
      })
    : emptyValue

  const label = getReserveLabel(listing)

  return [label, value]
}

ListingReserve.propTypes = {
  listing: PropTypes.object.isRequired,
  elmId: PropTypes.string.isRequired,
}

export default ListingReserve
